<dx-data-grid [dataSource]="order.files" [allowColumnReordering]="true" [showBorders]="true" class="mb-2" rowTemplate="rowTemplateName">
  <dxi-column dataField="fileName" caption="{{ 'FILENAME' | translate }}"></dxi-column>
  <dxi-column dataField="fileSize" caption="{{ 'SIZE' | translate }}"></dxi-column>
  <dxi-column dataField="fileAddDate" caption="{{ 'DATE_ADD' | translate }}" sortOrder="asc"></dxi-column>
  <dxi-column dataField="fileAuthor?.fio" caption="{{ 'AUTHOR_OF_ATTACHMENT' | translate }}"></dxi-column>

  <tbody class="dx-row" *dxTemplate="let order of 'rowTemplateName'">
    <tr class="main-row dx-row-lines dx-column-lines">
      <td>
        <label style="display: none">{{ 'FILENAME' | translate }}</label>
        <a [href]="getUrlById(order.data.id)">{{ order.data.fileName }}</a>
      </td>
      <td style="text-align: right">
        <label style="display: none">{{ 'SIZE' | translate }}</label>
        {{ order.data.fileSize }}
      </td>
      <td>
        <label style="display: none">{{ 'DATE_ADD' | translate }}</label>
        {{ order.data.fileAddDate | date: 'dd-MM-yyyy HH:mm:ss' }}
      </td>
      <td>
        <label style="display: none">{{ 'AUTHOR_OF_ATTACHMENT' | translate }}</label>
        {{ order.data.fileAuthor?.fio }}
      </td>
    </tr>
  </tbody>
</dx-data-grid>

<div class="d-flex align-items-center">
  <div class="file-upload text-center d-inline-block">
    <dx-file-uploader
      [multiple]="true"
      [showFileList]="true"
      selectButtonText="{{ 'SELECT_FILE' | translate }}"
      uploadMode="useForm"
      [maxFileSize]="getMaxFileSize()"
      [accept]="getSupportedFileFormat()"
      [allowedFileExtensions]="getSupportedFileFormat()"
      [(value)]="order.addedFiles"></dx-file-uploader>

    @if (this.isFilesSelected()) {
      <dx-button
        text="{{ 'UNSELECT_ALL_FILES' | translate }}"
        (onClick)="unselectAllFiles()"
        class="btn ms-2 btn-light"
        icon="mdi mdi-collapse-all-outline"></dx-button>
    }
  </div>

  <dx-button id="infoButton" (onClick)="info()" class="btn ms-2 btn-light" icon="mdi mdi-help"></dx-button>
</div>

<dx-popover target="#infoButton" position="top" [width]="400" [shading]="true" shadingColor="rgba(0, 0, 0, 0.5)" [(visible)]="showInfo">
  <div *dxTemplate="let data of 'content'">
    {{ 'SUPPORT_FILE_FORMAT' | translate }}
    <b>{{ getSupportedFileFormatString() }}</b>
    <br />
    {{ 'MAX_FILE_SIZE' | translate }}
    <b>{{ getMaxFileSize() / 1000000 }} mb</b>
  </div>
</dx-popover>
